import { isPresent } from "@apl-digital/utils";

import config from "@/constants/config";

export const isSSOEnabled = (): boolean => {
  return isPresent(config.ssoConfig.clientId);
};
